import _ from 'lodash';

export interface Breakpoints {
  xxl: number;
  xl: number;
  l: number;
  m: number;
  s: number;
  xs: number;
  xxs: number;
  xxxs: number;
  xxxxs: number;
}

const components: NodeListOf<Element> = document.querySelectorAll('.cont-dep');

const breakpoints: Breakpoints = {
  xxxxs: 260,
  xxxs: 320,
  xxs: 424,
  xs: 576,
  s: 768,
  m: 992,
  l: 1116,
  xl: 1440,
  xxl: 1600,
};

export class ContainerQueriesPolyfill {
  constructor() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.checkWidth(entry.target as HTMLElement);
      }
    });
    components.forEach((component) => {
      const parentComponent = component.parentElement;
      if (
        parentComponent?.classList.contains('col-100') ||
        parentComponent?.classList.contains('col-75') ||
        parentComponent?.classList.contains('col-50') ||
        parentComponent?.classList.contains('col-33') ||
        parentComponent?.classList.contains('col-25') ||
        parentComponent?.classList.contains('col-20')
      ) {
        resizeObserver.observe(parentComponent);
      }
    });
  }

  checkWidth(parentComponent: HTMLElement) {
    const component: HTMLElement | null = parentComponent.querySelector('.cont-dep') || null;

    let from = -1;
    let to = 0;
    _.forOwn(breakpoints, (breakpoint, key) => {
      from = _.clone(to);
      to = breakpoint;

      if (parentComponent.offsetWidth > from + 1 && parentComponent.offsetWidth <= to) {
        if (component) {
          component.classList.remove('size-xxxxs');
          component.classList.remove('size-xxxs');
          component.classList.remove('size-xxs');
          component.classList.remove('size-xs');
          component.classList.remove('size-s');
          component.classList.remove('size-m');
          component.classList.remove('size-l');
          component.classList.remove('size-xl');
          component.classList.remove('size-xxl');

          component.classList.add(`size-${key}`);
        }
      }
    });
  }
}
